/**
 * Genre entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Genre extends BaseModel {
    defaults() {
        return {
            id: null,
            title: null,
            description: null,
            genre_group_id: null,
            slug: null,
            display_order: null,
            link: null,
            html_title: null,
            genre_group_title: null,

            // view props:
            page_id: null,
            group_display_order: null,
            genre_group_html_title: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            genre_group_id: Number,
            display_order: Number,

            // view props:
            page_id: Number,
            group_display_order: Number,
        };
    }

    entityName() {
        return 'Genre';
    }
}

export class GenreCollection extends BaseCollection {
    options() {
        return {
            model: Genre,
        };
    }

    entityName() {
        return 'Genre';
    }
}
